import { type PayinTicket } from '~/entities/payin';
import { MODALS } from '~/shared/constants/modals';
import { closeResponsiveModal, openResponsiveModal } from '~/shared/ui/ResponsiveModals';

export const openTicketModal = (ticket: PayinTicket) =>
    openResponsiveModal({
        modalId: MODALS.PAYIN_TICKET_MANAGEMENT,
        innerProps: {
            ticket,
            onReslove: () => closeResponsiveModal(MODALS.PAYIN_TICKET_MANAGEMENT),
        },
        modal: MODALS.PAYIN_TICKET_MANAGEMENT,
        title: 'Управление заявкой',
    });
